import React from "react";
import { Row, Col } from "reactstrap";
import Error from "../../erros/Error";
import MaterialRunner from "./MaterialRunner";

const PreviewMaterial = ({ data, isLoaded }) => {
  return (
    <Row className="g-0 justify-content-center align-items-center h-100">
      <Col className="col-8">
        <div class="col-12 p-0 align-items-center rounded-5 border mt-5 bg-white">
          <div className="col-12 px-4 p-2 rounded-header border-bottom fs-5">
            <b>Create your own material in this style</b>
          </div>
          <div className="col-12 p-4 py-0">
            <p className="fst-italic py-2">Output style example:</p>
            {data.detail ? (
              <Error data={data} isLoaded={isLoaded} />
            ) : (
              <MaterialRunner
                data={data}
                isLoaded={isLoaded}
                display={"preview_material"}
              />
            )}
          </div>
          <div className="col-12 text-center px-4">
            <div className="col-12">
              {data?.is_premium && data?.user_subscription !== "Pro" ? (
                <button
                  type="button"
                  class="btn btn-warning px-3 rounded-5 fs-8"
                  data-bs-toggle="modal"
                  data-bs-target="#QPaymentModal"
                >
                  <b>Upgrade to use this template</b>
                </button>
              ) : (
                <a
                  href={`/material/generate/${data?.id}`}
                  rel="nofollow"
                  class="btn btn-darkblue px-3 rounded-5 fs-8"
                >
                  <b>Use this template</b>
                </a>
              )}
            </div>
            <div className="col-12 text-lgrey pt-2 pb-3">
              <span>
                Estimated credits:{" "}
                {data?.estimated_credits ? data?.estimated_credits : "n/a"}
              </span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default PreviewMaterial;
